export default __webpack_public_path__ + "static/media/malabon.2303b884.jpg";